import { tuApptoAPI, getAuthHeaders, getErrorData } from './config'

const headers = getAuthHeaders().headers
export const findAll = async id => {
  try {
    const response = await tuApptoAPI.get(`/visits/findall/${id}`, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const apartments = async id => {
  try {
    const response = await tuApptoAPI.get(`/visits/apartments/${id}`, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const create = async request => {
  try {
    const response = await tuApptoAPI.post('/visits/create', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const status = async request => {
  try {
    const response = await tuApptoAPI.put('/visits/status', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}

export const remove = async request => {
  try {
    const response = await tuApptoAPI.put('/visits/remove', request, {
      headers,
    })
    return response.data
  } catch (error) {
    return getErrorData(error)
  }
}
